import React, { useState } from "react";
import CIcon from '@coreui/icons-react'
import { cilLockLocked } from '@coreui/icons';
import { ChangePasswordAPI } from "../../API/player";
import { useSnackbar } from 'notistack';
import CryptoJS from 'crypto-js';
import { useDispatch } from 'react-redux';
import EyeIcon from '../../components/icons/EyeIcon';
import EyeSlashFillIcon from '../../components/icons/EyeSlashFillIcon';
import Swal from "sweetalert2";


import {
  CButton,
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CModalFooter,
  CFormInput,
  CForm,
} from '@coreui/react'
const ChangePassword = ({ onModalOpen, OnModalClose }) => {
  const dispatch = useDispatch()
  const [visible, setVisible] = useState(false)
  const [errors, setErrors] = useState({});
  const [PasswordCriteria, setPasswordCriteria] = useState({});
  const [CriteriaShow, setCriteriaShow] = useState(false);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const SECRET_KEY = process.env.REACT_APP_HASH_SECRET_KEY;;
  console.log("SECRET_KEY", SECRET_KEY);
  const [formData, setFormData] = useState(
    {
      old_password: '',
      new_password: ''
    }
  );
  const [showPassword, setShowPassword] = useState({ password: true, confirm_password: true });

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(formData);

    if (formData.old_password === '' || formData.new_password === '') {
      Swal.fire({
        title: "Invalid New Password or Old Password",
        text: "Old password or New password can not be blank.",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "OK",
          showCancelButton: true,
          cancelButtonColor: "#d33",
          cancelButtonText: "Close"

    });
      return;
    }

    // Check if old and new passwords are the same
    if (formData.old_password === formData.new_password) {

      Swal.fire({
        title: "Invalid New Password",
        text: "New password must be different from the old password.",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "OK",
          showCancelButton: true,
                cancelButtonColor: "#d33",
                cancelButtonText: "Close"

    })
      return; // Stop further execution
    }

    const passwordPattern = /^(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*()_+|~=`{}\[\]:;'<>?,./]).{8,}$/;

    // Validate both old_password and new_password against the pattern
    if (!passwordPattern.test(formData.old_password)) {
      Swal.fire({
        title: "Invalid Old Password",
        text: "Old password does not meet the requirements",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "OK",
          showCancelButton: true,
                cancelButtonColor: "#d33",
                cancelButtonText: "Close"

    })
      return; // Stop further execution
    }

    if (!passwordPattern.test(formData.new_password)) {

        Swal.fire({
                      title: "Invalid New Password",
                      text: "New password does not meet the requirements",
                      confirmButtonColor: "#3085d6",
                      confirmButtonText: "OK",
                        showCancelButton: true,
                cancelButtonColor: "#d33",
                cancelButtonText: "Close"

                  })

      return; // Stop further execution
    }
    const oldPassword = CryptoJS.AES.encrypt(formData.old_password, SECRET_KEY).toString();
    const newPassword = CryptoJS.AES.encrypt(formData.new_password, SECRET_KEY).toString();

    let encryptedPassword = {
      old_password: oldPassword,
      new_password: newPassword
    }
    let res = await ChangePasswordAPI(encryptedPassword);

    if (res.data.status) {
      console.log("passwpord", res.data)
      console.log("tooken", res.data.token)
      dispatch({ type: 'set', user: res.data.data });
      dispatch({ type: 'set', token: res.data.token });
      localStorage.setItem('token', res.data.token);
      localStorage.setItem('role', res.data.data.role);
      Swal.fire({
        title: "Password changed successfully",
        text: "Your password was reset successfully.",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "OK",
          showCancelButton: true,
                cancelButtonColor: "#d33",
                cancelButtonText: "Close"

    }).then(result => {
      if (result.isConfirmed) {
        // window.location.href('/logout')
        setFormData({
          old_password: '',
          new_password: ''
        });
        setVisible(false);
        window.location.reload();
      }
    })
    } else {
      Swal.fire({
        title:res.data.message,
        text: "You have provided wrong old password",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "OK",
          showCancelButton: true,
                cancelButtonColor: "#d33",
                cancelButtonText: "Close"

    })
    }
  };

  const PasswordValidation = (e) => {
    const { value } = e.target;
    const tempCriteria = {};
    tempCriteria.length = value.length >= 8;
    tempCriteria.uppercase = /[A-Z]/.test(value);
    tempCriteria.digit = /\d/.test(value);
    tempCriteria.special_character = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/.test(value);
    setPasswordCriteria(tempCriteria);
  }


  const HandelChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  }
  const togglePasswordVisibility = () => {
    setShowPassword(prevState => ({
      ...prevState,
      password: !prevState.password
    }));
  };

  const toggleConfirmPasswordVisibility = () => {
    setShowPassword(prevState => ({
      ...prevState,
      confirm_password: !prevState.confirm_password
    }));
  };
  return (
    <>
      {/* <CButton color="primary" style={{ background: "#202020", borderColor: "#202020" }} onClick={() => setVisible(!visible)} >
        <CIcon style={{ transform: 'scale(1.6)' }} icon={cilLockLocked} />
      </CButton> */}
      <CButton className="change_password_btn" onClick={() => { 
          setVisible(!visible);  // Use semicolon to separate statements
          onModalOpen(); 
      }}> 
    Change Password 
</CButton>

      <CModal
        alignment="center"
        visible={visible}
        onClose={() => {
          setVisible(false); 
          OnModalClose();
          setFormData({
            old_password: '',
            new_password: ''
          })
        }}
        aria-labelledby="VerticallyCenteredExample"
      >
        <CModalHeader>
          <CModalTitle id="VerticallyCenteredExample">Change Password</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <div className="position-relative">

            <CFormInput
              className="mb-3"
              type={showPassword.password ? "password" : "text"}
              pattern="^(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*()_+|~=`{}\[\]:;'<>?,./]).{8,}$"
              title="Password must be at least 8 characters long, include at least one uppercase letter, one digit, and one special character."
              id="oldpassword"
              label="Old Password"
              placeholder="Old password"
              required
              name="old_password"
              value={formData.old_password}
              onChange={HandelChange}
            />
            <i className="btn border-0 position-absolute end-0 " type="button" onClick={togglePasswordVisibility} style={{ top: "30px" }}>

              {
                showPassword.password ? <EyeIcon /> : <EyeSlashFillIcon />
              }
            </i>
          </div>
          <div className="position-relative">

            <CFormInput
              type={showPassword.confirm_password ? "password" : "text"}
              id="newpassword"
              pattern="^(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*()_+|~=`{}\[\]:;'<>?,./]).{8,}$"
              title="Password must be at least 8 characters long, include at least one uppercase letter, one digit, and one special character."
              label="New Password"
              placeholder="New password"
              name="new_password"
              onChange={(e) => { HandelChange(e); PasswordValidation(e); }}
              onFocus={() => { setCriteriaShow(true) }}
              onBlur={() => { setCriteriaShow(false) }}
              value={formData.new_password}
              required
            // onChange={{ HandelChange PasswordValidation(e); }}

            />
            <i className="btn border-0 position-absolute end-0 " onClick={toggleConfirmPasswordVisibility} style={{ top: "30px" }} >
              {
                showPassword.confirm_password ? <EyeIcon /> : <EyeSlashFillIcon />
              }
            </i>
          </div>
          <div>
            {
              !CriteriaShow && !formData.new_password.trim() ?
                errors.new_password && <span className='text-danger'>{errors.new_password}</span>
                :

                <span className={PasswordCriteria.length && PasswordCriteria.uppercase && PasswordCriteria.digit && PasswordCriteria.special_character ? 'text-success' : 'text-danger'}>

                  <span className={PasswordCriteria.length !== undefined && PasswordCriteria.length ? 'text-success' : 'text-danger'} data-length={PasswordCriteria.length}>Password must be at least 8 characters long</span> <br />

                  <span className={PasswordCriteria.uppercase !== undefined && PasswordCriteria.uppercase ? 'text-success' : 'text-danger'} data-length={PasswordCriteria.uppercase}>Contain at least one uppercase letter</span><br />

                  <span className={PasswordCriteria.digit !== undefined && PasswordCriteria.digit ? 'text-success' : 'text-danger'} data-length={PasswordCriteria.digit}>One digit</span>, and

                  <span className={PasswordCriteria.special_character !== undefined && PasswordCriteria.special_character ? 'text-success' : 'text-danger'} data-length={PasswordCriteria.special_character}> one special character</span>.
                  <br /> <br /></span>
            }
          </div>
        </CModalBody>
        <CModalFooter>
          <CButton color="secondary" onClick={() => {
            setVisible(false);OnModalClose() ;setFormData({
              old_password: '',
              new_password: ''
            })
          }
          }>
            Close
          </CButton>
          <CButton type="submit" onClick={(e) => handleSubmit(e)} color="primary">Save changes</CButton>
        </CModalFooter>
      </CModal>


    </>
  )

}
export default ChangePassword
